// extracted by mini-css-extract-plugin
module.exports = {"OurValues":"OurValues-module__OurValues___rXPOc"};